import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";
import { columnFilterSchema } from "../../../common/columnFilterSchema";
import { cursorSchema } from "../../../common/cursorSchema";
import { statsSchema, merchStatsSchema } from "../../../common/statsSchema";

const categoryStatsSchema = merchStatsSchema.extend({
  seo_score: z.number().nullable(),
  seo_score_prev: z.number().nullable(),
  seo_score_delta: z.number().nullable(),
  seo_score_percent: z.number().nullable(),

  buyability_score: z.number().nullable(),
  buyability_score_prev: z.number().nullable(),
  buyability_score_delta: z.number().nullable(),
  buyability_score_percent: z.number().nullable(),
});

export const categoryReportApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getV4CategoryReportByCategory",
    method: "get",
    path: "/v4/query/?table=category&grouping=category_id",
    parameters: [
      {
        name: "search",
        type: "Query",
        schema: z.string().array().optional(),
      },
      {
        name: "marketplace",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "start_date",
        type: "Query",
        schema: z.string().date(),
      },
      {
        name: "end_date",
        type: "Query",
        schema: z.string().date(),
      },
      {
        name: "start_date_previous",
        type: "Query",
        schema: z.string().date(),
      },
      {
        name: "end_date_previous",
        type: "Query",
        schema: z.string().date(),
      },
      {
        name: "filters",
        type: "Query",
        schema: columnFilterSchema,
      },
      {
        name: "cursor",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "limit",
        type: "Query",
        schema: z.number().optional(),
      },
      {
        name: "ordering",
        type: "Query",
        schema: z.string().optional(),
      },
    ],
    status: 200,
    response: z.object({
      data: z.array(
        z
          .object({
            category_id: z.number(),
            category_name: z.string(),
          })
          .merge(statsSchema)
          .merge(categoryStatsSchema),
      ),
      cursor: cursorSchema,
      count: z.number(),
    }),
  })
    .addEndpoint({
      alias: "getV4CategoryReportByDate",
      method: "get",
      path: "/v4/query/?table=category&grouping=start_date&limit=1000000&include_count=false",
      parameters: [
        {
          name: "search",
          type: "Query",
          schema: z.string().array().optional(),
        },

        {
          name: "marketplace",
          type: "Query",
          schema: z.string(),
        },
        {
          name: "start_date",
          type: "Query",
          schema: z.string().date(),
        },
        {
          name: "end_date",
          type: "Query",
          schema: z.string().date(),
        },
        {
          name: "start_date_previous",
          type: "Query",
          schema: z.string().date(),
        },
        {
          name: "end_date_previous",
          type: "Query",
          schema: z.string().date(),
        },
        {
          name: "date_group",
          type: "Query",
          schema: z.string(),
        },
        {
          name: "filters",
          type: "Query",
          schema: columnFilterSchema,
        },
      ],
      status: 200,
      response: z.object({
        data: z.array(
          z
            .object({
              start_date: z.string().date(),
            })
            .merge(statsSchema)
            .merge(categoryStatsSchema),
        ),
        cursor: cursorSchema,
        count: z.number(),
      }),
    })
    .addEndpoint({
      alias: "getV4CategoryReportTotals",
      method: "get",
      path: "/v4/query/aggregate/?table=category",
      parameters: [
        {
          name: "search",
          type: "Query",
          schema: z.string().array().optional(),
        },
        {
          name: "marketplace",
          type: "Query",
          schema: z.string(),
        },
        {
          name: "start_date",
          type: "Query",
          schema: z.string().date(),
        },
        {
          name: "end_date",
          type: "Query",
          schema: z.string().date(),
        },
        {
          name: "start_date_previous",
          type: "Query",
          schema: z.string().date(),
        },
        {
          name: "end_date_previous",
          type: "Query",
          schema: z.string().date(),
        },
        {
          name: "filters",
          type: "Query",
          schema: columnFilterSchema,
        },
      ],
      status: 200,
      response: z.object({
        data: statsSchema.merge(categoryStatsSchema),
      }),
    })
    .addEndpoint({
      alias: "getV4CategoryReportExport",
      method: "get",
      path: "/v4/query/?table=category&xls=true&report_type=category_report",
      parameters: [
        {
          name: "marketplace",
          type: "Query",
          schema: z.string(),
        },
        {
          name: "start_date",
          type: "Query",
          schema: z.string().date(),
        },
        {
          name: "end_date",
          type: "Query",
          schema: z.string().date(),
        },
        {
          name: "filters",
          type: "Query",
          schema: columnFilterSchema,
        },
      ],
      status: 200,
      response: z.instanceof(Blob),
    })
    .build(),
);
